const SortIconAscending = ({ topLetter = "A", bottomLetter = "Z" }) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g id='Asc-eng'>
      <g id='Group 1522'>
        <g id='Group 1521'>
          <text
            id='topLetter'
            fill='black'
            fillOpacity='0.85'
            xmlSpace='preserve'
            fontFamily='Noto Sans'
            fontSize='8'
            fontWeight='bold'
            letterSpacing='0.005em'
          >
            <tspan x='9.42969' y='6.22058'>
              {topLetter}
            </tspan>
          </text>
          <text
            id='bottomLetter'
            fill='black'
            fillOpacity='0.85'
            xmlSpace='preserve'
            fontFamily='Noto Sans'
            fontSize='8'
            fontWeight='bold'
            letterSpacing='0.005em'
          >
            <tspan x='9.42969' y='14.2206'>
              {bottomLetter}
            </tspan>
          </text>
          <path
            id='Subtract'
            d='M4.77733 2.19434C4.79665 2.20381 4.81386 2.21744 4.82713 2.23438L6.82713 4.76855C6.90196 4.86129 6.83415 5.0006 6.71483 5.00098H5.35741V14.4648C5.35741 14.5433 5.29318 14.6081 5.21483 14.6084H4.21483C4.13626 14.6084 4.07128 14.5434 4.07128 14.4648V5.00098H2.71483C2.59521 5.00098 2.52662 4.8632 2.60155 4.76855L4.60155 2.23438C4.61483 2.21744 4.63203 2.20381 4.65135 2.19434C4.67085 2.18484 4.69315 2.17969 4.71483 2.17969C4.73635 2.17976 4.75798 2.18491 4.77733 2.19434Z'
            fill='black'
            fillOpacity='0.85'
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SortIconAscending;
